import { DOCUMENT } from '@angular/common';
import { effect, inject, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { userAccount } from '@features/auth/store/auth.signals';
import { filter } from 'rxjs';

const userAccountClass = 'prnyc-user';
const userAccountMissingClass = 'prnyc-user-missing';

@Injectable({ providedIn: 'root' })
export class PageTrackerService {
    private readonly document = inject(DOCUMENT);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);

    private currentPageKey: string | null = null;

    public initialize(): void {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.updateBodyClass(this.getRouteKey());
        });

        // Set initial class on app load
        this.updateBodyClass(this.getRouteKey());

        effect(() => {
            const user = userAccount();

            if (!user) {
                this.document.documentElement.classList.remove(userAccountClass);
                this.document.documentElement.classList.add(userAccountMissingClass);

                return;
            }

            this.document.documentElement.classList.remove(userAccountMissingClass);
            this.document.documentElement.classList.add(userAccountClass);
        });
    }

    private getRouteKey(): string | null {
        let { route } = this;

        while (route.firstChild) {
            route = route.firstChild;
        }

        const key = route.snapshot.data?.['key'];

        return typeof key === 'string' ? key : null;
    }

    private updateBodyClass(newKey: string | null): void {
        if (this.currentPageKey) {
            this.document.documentElement.classList.remove(this.currentPageKey);
        }

        if (newKey) {
            this.document.documentElement.classList.add(newKey);
            this.currentPageKey = newKey;
        }
    }
}
